import commonUtils from "../../utils/common.utils";
import OrderSpecsModel from "../orderSpecs.model";
import ComboSpecsModel from "../comboSpecs.model";
import { normalizeProductNameForApi } from "@/utils/productName.utils";

export default class OrderGoods {
    constructor(data) {
        this.id = commonUtils.generateId();
        this.orderCount =  data.orderGood.quantity;
        this.vipLevel = data.vipLevel;
        if (data.orderGood.note) {
            this.note = data?.orderGood?.note || ''
        }

        if (!data.orderGood.isCombo) {
            // 送 API 用商品名稱（第1段），名稱正規化後 clone，不影響購物車原物件
            this.product = normalizeProductNameForApi(data.orderGood.product);
            this.orderSpecs = data.orderGood.settings.map(setting => new OrderSpecsModel(setting));
        } else {
            const combo = new ComboSpecsModel(data.orderGood);
            this.combo = normalizeProductNameForApi(data.orderGood.product);
            this.orderProducts = combo.fixedProducts.map(normalizeProductNameForApi);
            this.orderComboSubs = combo.orderComboSubs.map(normalizeProductNameForApi);
            this.orderComboSubAny = normalizeProductNameForApi(combo.orderComboSubAny);
            this.cleanComboSettings(this.combo.comboSubSettings);
        }
    }

    cleanComboSettings(comboSubSettings) {
        comboSubSettings.forEach(group => {
            delete group.productSelectCount;
            delete group.allProducts;
            delete group.products;
            delete group.markUpProducts;
        });
    }
}